import React from 'react';
import { Check, X } from 'lucide-react';
import { comparisonData } from '../data/mockData';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const ComparisonSection = () => {
  const header = useScrollAnimation({ threshold: 0.15 });
  const content = useScrollAnimation({ threshold: 0.1 });
  return (
    <section data-testid="comparison-section" className="py-16 md:py-32 bg-[#F5F3FF]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div ref={header.ref} className={`text-center max-w-2xl mx-auto mb-16 scroll-fade-up ${header.isVisible?'scroll-visible':''}`}>
          <span className="text-xs tracking-[0.2em] uppercase text-[#6366F1] mb-3 block font-semibold">The Difference</span>
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[#1E1B4B] mb-4" style={{fontFamily:"'Playfair Display',serif"}}>Before & After Registration</h2>
          <p className="text-base font-normal text-[#4B5563] leading-relaxed">A single federal filing transforms your legal standing entirely.</p>
        </div>
        <div ref={content.ref} className={`grid md:grid-cols-2 gap-0 max-w-5xl mx-auto border border-[#E2E2F0] rounded-2xl overflow-hidden scroll-fade-up scroll-delay-2 ${content.isVisible?'scroll-visible':''}`}>
          <div className="bg-white p-6 md:p-8 border-b md:border-b-0 md:border-r border-[#E2E2F0]">
            <div className="flex items-center gap-3 mb-6 pb-4 border-b border-[#E2E2F0]">
              <div className="w-8 h-8 bg-red-50 flex items-center justify-center"><X className="w-4 h-4 text-red-600" strokeWidth={2} /></div>
              <h3 className="text-lg font-semibold text-[#1E1B4B]" style={{fontFamily:"'Playfair Display',serif"}}>Without Registration</h3>
            </div>
            <ul className="space-y-4">
              {comparisonData.without.map((item,i)=>(
                <li key={i} data-testid={`comparison-without-${i}`} className="flex items-start gap-3">
                  <X className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" strokeWidth={2} />
                  <span className="text-sm font-normal text-[#374151] leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-[#1E1B4B] p-6 md:p-8">
            <div className="flex items-center gap-3 mb-6 pb-4 border-b border-white/10">
              <div className="w-8 h-8 bg-[#6366F1]/15 flex items-center justify-center"><Check className="w-4 h-4 text-[#6366F1]" strokeWidth={2} /></div>
              <h3 className="text-lg font-semibold text-white" style={{fontFamily:"'Playfair Display',serif"}}>With Federal Protection</h3>
            </div>
            <ul className="space-y-4">
              {comparisonData.with.map((item,i)=>(
                <li key={i} data-testid={`comparison-with-${i}`} className="flex items-start gap-3">
                  <Check className="w-4 h-4 text-[#6366F1] mt-0.5 flex-shrink-0" strokeWidth={2} />
                  <span className="text-sm font-normal text-white/60 leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
export default ComparisonSection;
